module.exports = __webpack_public_path__ + "img/sunrise_icon.31b09e41.svg";